import React from "react";

// Temporary landing page shown in place of the dip submission form while
// it's disabled (2026-04-09).
function DipFormDisabled() {
    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h1 style={styles.title}>Water Test &amp; Tank Seal Integrity</h1>
                <p style={styles.body}>
                    Dip submission form is temporarily unavailable.
                    Please record your dip results on paper.
                </p>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: "100vh",
        backgroundColor: "#0f172a",
        color: "#e2e8f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        fontFamily: "system-ui, -apple-system, sans-serif",
    },
    card: {
        maxWidth: 500,
        width: "100%",
        backgroundColor: "#1e293b",
        border: "1px solid #334155",
        borderRadius: 12,
        padding: "28px 24px",
        textAlign: "center",
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        margin: "0 0 20px 0",
        color: "#f1f5f9",
    },
    body: {
        fontSize: 16,
        lineHeight: 1.55,
        margin: 0,
        color: "#cbd5e1",
    },
};

export default DipFormDisabled;
